import { Button, Typography } from '@mui/material';
import './Orientacoes3.scss';

import { useAtom } from 'jotai';
import { FC, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { accessToken } from '../../atoms/atom';

const Orientacoes3: FC = () => {
	const { id } = useParams<{ id: string }>();
	const [accessTokenAtom] = useAtom(accessToken);
	const isMounted = useRef(true);
	const navigate = useNavigate();

	const next = () => {
		navigate(`/${id}/pergunta`);
	}

	useEffect(() => {
		const token = accessTokenAtom || localStorage.getItem("access-token");
		if (!token && isMounted.current) {
			navigate(`/${id}/login`);
		}
	}, [accessTokenAtom]);

	return (
		<div className="orientations3">
			<div className="orientations-data3">
				<Typography variant='h6' align='justify'>
					As últimas 2 perguntas são opcionais, mas, suas respostas nos ajudarão muito a melhorar
					os programas de saúde mental na empresa. Por isso, se você puder, por favor, responda
					com sinceridade e contribua com a melhoria contínua da gestão de riscos ocupacionais.
				</Typography>
			</div>
			<Button onClick={() => next()} variant='contained' color='primary' size='large'>
				Continuar
			</Button>
		</div>
	)
}

export default Orientacoes3;